const STORAGE_PREFIX = 'specific:reseller-assignment'

const canonicalQuantity = (quantity) => {
  const parsed = Number(quantity)
  return Number.isFinite(parsed) ? parsed.toString() : String(quantity)
}

const getSessionStorage = () => {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export const createAssignmentRequestId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export const buildAssignmentStorageKey = ({companyId, resourceId, quantity}) =>
  [
    STORAGE_PREFIX,
    encodeURIComponent(companyId),
    encodeURIComponent(resourceId),
    encodeURIComponent(canonicalQuantity(quantity)),
  ].join(':')

export const getOrCreateAssignmentRequest = (
  descriptor,
  storage = getSessionStorage(),
  createId = createAssignmentRequestId
) => {
  const storageKey = buildAssignmentStorageKey(descriptor)
  const storedRequestId = storage?.getItem(storageKey)
  if (storedRequestId) {
    return {requestId: storedRequestId, storageKey}
  }

  const requestId = createId()
  storage?.setItem(storageKey, requestId)
  return {requestId, storageKey}
}

export const clearAssignmentRequest = (storageKey, storage = getSessionStorage()) => {
  storage?.removeItem(storageKey)
}
